export const sampleTumeloAccount = () => {
    return {
        id: '0F5C8F93-480E-4A8B-B780-8EF63B319716',
        title: 'Account A',
        modelPortfolioId: '2DD1596D-9518-4304-9A06-D01708CF3707',
    };
};
